<style scoped>
  @import '../../static/css/swiper-3.4.2.min.css';

  .swiper-slide .active{
    color: #0077db;
  }
  .swiper-container {
    height: 50px;
    font-size: 14px;
    background: white;
  }
  .swiper-wrapper .active {
    color: #0077db;
    border-bottom: 2px solid;
  }
</style>

<template>
  <div>
    <div class="swiper-container" v-bind:style="{width: width, height: height}">
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from '../../static/js/swiper-3.4.2.min'

  export default {
    props: {
      height: {
        type: String,
        default: '50px'
      },
      width: {
        type: String,
        default: 'auto'
      }
    },
    updated () {
      let mySwiper = new Swiper('.swiper-container', {
        autoplay: 0, // 可选选项，自动滑动
        slidesPerView: 'auto',
        freeMode: true,
        freeModeSticky : true,
        slideToClickedSlide:true,
        prevButton:'.swiper-button-prev',
        nextButton:'.swiper-button-next'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// SlideTabContainer.vue?eda40816